import { render } from "./InstancesTemplate.vue?vue&type=template&id=c72bdb98&scoped=true&ts=true"
import script from "./InstancesTemplate.vue?vue&type=script&lang=ts"
export * from "./InstancesTemplate.vue?vue&type=script&lang=ts"

import "./InstancesTemplate.vue?vue&type=style&index=0&id=c72bdb98&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72bdb98"]])

export default __exports__